import { useContext } from 'react';
import LanguageContext from './LanguageContext';

export default function useLocale() {
  const { lang, t, setLanguage, updateLocaleForLang, locale } = useContext(LanguageContext);
  return { lang, t, setLanguage, updateLocaleForLang, locale };
}
